import {TbankSendResponseDto} from '../../../../global/api';
import {formatShortDate} from '../../helpers';
import {HistoryDownload} from './HistoryDownload';
import {HistoryInvoiceNumber} from './HistoryInvoiceNumber';
import {HistoryStatus} from './HistoryStatus';

export type PaymentTransaction = TbankSendResponseDto & {
  invoiceNumber?: string | number;
  invoiceDate?: string;
  paymentDate?: string;
  innerContractNumber?: string;
  payerName?: string;
  status?: TbankSendResponseDto['status'];
};

export const TABLE_CELL_META = [
  {
    id: 0,
    key: 'invoiceNumber',
    label: 'СЧЕТ',
    align: 'left',
    render: (data: PaymentTransaction) => (
      <HistoryInvoiceNumber href={data.incomingInvoiceUrl} invoiceNumber={data.invoiceNumber} />
    ),
  },
  {
    id: 1,
    key: 'invoiceDate',
    label: 'СОЗДАН',
    align: 'left',
    render: (data: PaymentTransaction) => formatShortDate(data.invoiceDate || data.createDate),
  },
  {
    id: 2,
    key: 'paymentDate',
    label: 'ОПЛАЧЕН',
    align: 'left',
    render: (data: PaymentTransaction) => formatShortDate(data.paymentDate),
  },
  {
    id: 3,
    key: 'amount',
    label: 'СУММА',
    align: 'left',
    render: (data: PaymentTransaction) => data.value ?? '-',
  },
  {
    id: 4,
    key: 'status',
    label: 'СТАТУС',
    align: 'left',
    render: (data: PaymentTransaction) => <HistoryStatus status={data.status} />,
  },
  {
    id: 5,
    key: 'contract',
    label: 'ДОГОВОР',
    align: 'left',
    render: (data: PaymentTransaction) => (data.innerContractNumber ? `№ ${data.innerContractNumber}` : '-'),
  },
  {
    id: 6,
    key: 'payer',
    label: 'ПЛАТЕЛЬЩИК',
    align: 'left',
    render: (data: PaymentTransaction) => data.payerName || '-',
  },
  {
    id: 7,
    key: 'download',
    label: 'СКАЧАТЬ СЧЁТ',
    align: 'left',
    render: (data: PaymentTransaction) => <HistoryDownload docUrl={data.incomingInvoiceUrl} pdfUrl={data.pdfUrl} />,
  },
] as const;
